import {Grid} from "@mui/material";
import ImageSlider from "./home/components/ImageSlider";
import HomeSolicitationsSummary from "./home/components/HomeSolicitationsSummary";


const Index = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <ImageSlider />
            </Grid>
            <Grid item xs={12} container spacing={2}>
                
                {
                    
                    /*
                    <Grid item xs={12} md={4}>
                        <TimelineHomeCard />
                    </Grid>
                     */
                }
                <Grid item xs={12} container>
                    <HomeSolicitationsSummary />
                </Grid>
            </Grid>
        </Grid>
    )
}


export default Index